<template>
  <h1>{{ msg }}</h1>
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      msg: 'This is search page'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this page only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Search.vue?34c52a7b